import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ApsContainer, ApsContentContainer, ApsPageTitle } from "UserExperience/portal-vnext";
import DocumentPages from "./DocumentPages";
import {isMobile} from 'react-device-detect';
import { useSession } from "../../common/session/SessionContext";

const AddDocument = props => {

  const { t } = useTranslation();
  const history = useHistory();
  const { activeDocument } = useSession();
  const pageTitle = t('addDocumentScreen.title');

  if (!activeDocument) {
    history.push('/start');
  }

  const goBack = () => {
    history.goBack();
  }  

  return (
    <>
      <ApsPageTitle titleText={pageTitle} />

      <ApsContentContainer containerPadding={true}>
        <ApsContainer
          containerPadding={true}
          containerType="content"
        >
          <DocumentPages
            document={activeDocument}
            isMobile={isMobile}
            headerTitleAlign="center"
            headerTitleSize="small"
            onFinish={goBack}
            onCancel={goBack}
          />
        </ApsContainer>
      </ApsContentContainer>
    </>
  );
}

export default AddDocument;